import {RecordForm} from '../forms/RecordForm';


import {useBankAccount} from '../hooks/useBankAccount.ts';
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useParams} from "react-router-dom";
import {AddPageNavigation} from "../navigation/BreadcrumbsNavigation.tsx";
import {BankAccount} from '../types';


export const AddPage = () => {

    const {id: customerId} = useParams();

    if (typeof customerId === 'undefined') {
        throw new Error('customerId is required parameter')
    }

    const {
        createRecord,
    } = useBankAccount(customerId);

    const emptyRecord = {
        customerId: customerId,
        country: '',
        currency: '',
        routingNumber: '',
        accountNumber: '',
        accountHolderName: '',
        accountHolderType: '',
    } as Omit<BankAccount, 'id'>;

    return (
        <FormPageLayout
            title='Add Bank Account'
            pageNavigation={<AddPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={emptyRecord} handleSubmit={createRecord}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
